import { useState } from 'react';
import { GraphQLError } from 'graphql';

export default function useErrorBoundary(): [
	GraphQLError | undefined,
	<F extends Function>(fn: F) => F,
	() => void,
] {
	const [error, setError] = useState(undefined);
	return [
		error,
		<F extends Function>(fn: F): F => {
			return ((async (...args: any[]) => {
				setError(undefined);
				try {
					return await fn(...args);
				} catch (error: any) {
					if (!error.graphQLErrors) {
						throw error;
					}

					setError(
						error.graphQLErrors[0] || {
							extensions: {
								error: {
									key: 'common.errors.offline',
								},
							},
						},
					);
				}
			}) as unknown) as F;
		},
		() => setError(undefined),
	];
}
